import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { ChangeRelationTypeKeys, EChangeRelationType } from 'src/types'

export function createRelationPageUrl(
  relationType: ChangeRelationTypeKeys,
  id?: string,
  accountId?: string,
) {
  switch (relationType) {
    case EChangeRelationType.step:
      return joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.STEPS, id)
    case EChangeRelationType.product:
      return joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.PRODUCTS, id)
    case EChangeRelationType.impact:
      return joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.IMPACTS, id)
    case EChangeRelationType.journey:
      return joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.JOURNEYS, id)
    case EChangeRelationType.account:
      return joinAbsRoute(ROUTES.ACCOUNTS, id, ROUTES.ACCOUNT)
    case EChangeRelationType.un_sdg:
      return joinAbsRoute(ROUTES.UN_SDG)
    case EChangeRelationType.library_impact:
      return joinAbsRoute(ROUTES.IMPACTS_LIBRARY, id)
    case EChangeRelationType.quantity_type:
      return joinAbsRoute(ROUTES.QUANTITY_TYPES)
    case EChangeRelationType.impact_period:
      return joinAbsRoute(ROUTES.IMPACT_PERIODS)
    case EChangeRelationType.impact_type:
      return joinAbsRoute(ROUTES.IMPACT_TYPES)
    case EChangeRelationType.scan:
      return joinAbsRoute(ROUTES.SCAN_HISTORY)
    case EChangeRelationType.media:
      return joinAbsRoute(ROUTES.MEDIA_VAULT)
    case EChangeRelationType.redirect_url:
      return joinAbsRoute(ROUTES.REDIRECT_URLS)
    case EChangeRelationType.approval_feedback:
      return joinAbsRoute(ROUTES.APPROVAL_FEEDBACKS)
    case EChangeRelationType.decline_reason:
      return joinAbsRoute(ROUTES.DECLINE_REASONS)
    case EChangeRelationType.reward_point:
      return joinAbsRoute(ROUTES.REWARD_POINTS)
    case EChangeRelationType.challenge:
      return joinAbsRoute(ROUTES.CHALLENGES)
    case EChangeRelationType.cron_job:
      return joinAbsRoute(ROUTES.CRON_JOBS)
    default:
      return ''
  }
}
